import {
  createButtonVariant,
  RANK_PRIMARY,
  RANK_SECONDARY,
  RANK_TERTIARY,
  RANK_TEXT,
  RANK_TEXT_REGULAR,
  SIZE_S,
  SIZE_M,
  SIZE_L,
} from './src';

export { Button } from './src';

export const PrimaryButtonSmall = createButtonVariant(
  'PrimaryButtonSmall',
  SIZE_S,
  RANK_PRIMARY
);

export const PrimaryButtonMedium = createButtonVariant(
  'PrimaryButtonMedium',
  SIZE_M,
  RANK_PRIMARY
);
export const PrimaryButtonLarge = createButtonVariant(
  'PrimaryButtonLarge',
  SIZE_L,
  RANK_PRIMARY
);
export const PrimaryButton = PrimaryButtonMedium;

export const SecondaryButtonSmall = createButtonVariant(
  'SecondaryButtonSmall',
  SIZE_S,
  RANK_SECONDARY
);
export const SecondaryButtonMedium = createButtonVariant(
  'SecondaryButtonMedium',
  SIZE_M,
  RANK_SECONDARY
);
export const SecondaryButtonLarge = createButtonVariant(
  'SecondaryButtonLarge',
  SIZE_L,
  RANK_SECONDARY
);
export const SecondaryButton = SecondaryButtonMedium;

export const TertiaryButtonSmall = createButtonVariant(
  'TertiaryButtonSmall',
  SIZE_S,
  RANK_TERTIARY
);
export const TertiaryButtonMedium = createButtonVariant(
  'TertiaryButtonMedium',
  SIZE_M,
  RANK_TERTIARY
);
export const TertiaryButtonLarge = createButtonVariant(
  'TertiaryButtonLarge',
  SIZE_L,
  RANK_TERTIARY
);
export const TertiaryButton = TertiaryButtonMedium;

export const TextButtonSmall = createButtonVariant(
  'TextButtonSmall',
  SIZE_S,
  RANK_TEXT
);
export const TextButtonMedium = createButtonVariant(
  'TextButtonMedium',
  SIZE_M,
  RANK_TEXT
);
export const TextButtonLarge = createButtonVariant(
  'TextButtonLarge',
  SIZE_L,
  RANK_TEXT
);
export const TextButton = TextButtonMedium;

export const TextButtonRegularSmall = createButtonVariant(
  'TextButtonRegularSmall',
  SIZE_S,
  RANK_TEXT_REGULAR
);
export const TextButtonRegularMedium = createButtonVariant(
  'TextButtonRegularMedium',
  SIZE_M,
  RANK_TEXT_REGULAR
);
export const TextButtonRegularLarge = createButtonVariant(
  'TextButtonRegularLarge',
  SIZE_L,
  RANK_TEXT_REGULAR
);
export const TextButtonRegular = TextButtonRegularMedium;

/* @deprecated */
export const GhostButtonSmall = TertiaryButtonSmall;
export const GhostButtonMedium = TertiaryButtonMedium;
export const GhostButtonLarge = TertiaryButtonLarge;
export const GhostButton = TertiaryButtonMedium;
